import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';
enum TabType {
	nothing,
	magillForceps,
	suction,
	manipulateLarynx,
	blank
}
var timeout: any = null;

const EttSpecialUI = (props: UIProperties<EttSpecialUIConfig>) => {
	const [tab, setTab] = useState(TabType.nothing);
	const [text, setText] = useState('');
	const [spinnerText, setSpinnerText] = useState('');

	const updateTab = (tab: TabType) => {
		setTab(tab);
		var currentTabData: EttSpecialUIItemConfig = null;
		switch(tab) {
			case TabType.blank:
				(currentTabData as any) = {};
				currentTabData.onClick = props.parameters.magillForceps.onClick;
				currentTabData.text = props.parameters.magillForceps.text;
				break;
			case TabType.magillForceps:
				currentTabData = props.parameters.magillForceps;
				break;
			case TabType.suction:
				setSpinnerText('SUCTION IN PROGRESS');
				currentTabData = props.parameters.suction;
				break;
			case TabType.manipulateLarynx:
				setSpinnerText('LARYNGEAL MANIPULATION IN PROGRESS');
				currentTabData = props.parameters.manipulateLarynx;
				break;
		}
		setText(currentTabData.text());
		if(currentTabData.onClick) {
			currentTabData.onClick();
		}

		if(timeout) {
			clearTimeout(timeout);
			timeout = null;
		}

		timeout = setTimeout(() => {
			setSpinnerText('');
			clearTimeout(timeout);
			timeout = null;
		}, 3000);
		
	}
	if(tab === TabType.nothing) {
		updateTab(TabType.blank);
	}
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '800px',
				height: '640px',
				border: '3px solid rgb(192, 161, 6)',
				backgroundColor: 'rgb(36, 36, 36)',
			}} id="ett-special-ui-top" tabIndex={0}>
				<div style={{
					position: 'absolute',
					left: '50%',
					top: '50px',
					transform: 'translate(-50%, 0)',
					width: '750px',
					height: '80px'
				}}>
					<GeneralButtonWithText parameters= {{
						text: 'Magill Forceps',
						top: '0',
						left: '0px',
						width: '250px',
						isDisabled: !props.parameters.magillForceps.isEnabled,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: "./assets/images/main-menu/button_menu_exit.png",
						shouldLeaveOn: tab === TabType.magillForceps,
						customDisabledMainStyle: {
							opacity: 0.5
						},
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							updateTab(TabType.magillForceps);
						}
					}}/>

					<GeneralButtonWithText parameters= {{
						text: 'Suction',
						top: '0',
						left: '257px',
						width: '250px',
						isDisabled: tab === TabType.suction,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: "./assets/images/main-menu/button_menu_exit_down.png",
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							updateTab(TabType.suction);
						}
					}}/>

					<GeneralButtonWithText parameters= {{
						text: 'Manipulate Larynx',
						top: '0',
						left: '507px',
						width: '250px',
						isDisabled: tab === TabType.manipulateLarynx,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: "./assets/images/main-menu/button_menu_exit_down.png",
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							updateTab(TabType.manipulateLarynx);
						}
					}}/>

				</div>
				{spinnerText === '' ? (
					<div style={{
						position: 'absolute',
						left: '20px',
						top: '200px',
						width: '751px',
						height: '310px',
						cursor: tab === TabType.magillForceps ? 'url("./assets/images/ett/forceps-icon.png"), auto' : 'default',
						pointerEvents: 'all'
					}}>
						<div style={{
							position: 'absolute',
							left: '280px',
							top: '20px',
							width: '200px',
							height: '200px',
							overflow: 'hidden',
							borderRadius: '105px'
						}}>
							<img style={{
								transform: 'scale(1.5)'
							}} onClick={() => {
								if(tab === TabType.magillForceps && props.parameters.magillForceps.onAirwayImageClicked) {
									props.parameters.magillForceps.onAirwayImageClicked();
									props.parameters.magillForceps.isEnabled = false;

									updateTab(TabType.blank);
								}
							}} src={props.parameters.airwayImage()} alt="" />
						</div>
						<p tabIndex={0} style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							position: 'absolute',
							bottom: '13px',
							width: '100%'
						}} className="title-font">{text}</p>
						<GeneralButtonWithText parameters= {{
							text: 'Abort',
							top: '320px',
							left: '180px',
							width: '180px',
							isDisabled: false,
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							srcDisabled: null,
							customImgStyle: {
								width: '100%'
							},
							customButtonStyle : {
								width: '100%'
							},
							customTextStyle: {
								fontSize: '17pt'
							},
							onClicked: () => {
								props.parameters.onAbortClicked();
							}
						}}/>
						<GeneralButtonWithText parameters= {{
							text: 'Next',
							id: 'ett-special-ui-bottom',
							top: '320px',
							left: '400px',
							width: '180px',
							isDisabled: false,
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							srcDisabled: null,
							customImgStyle: {
								width: '100%'
							},
							customButtonStyle : {
								width: '100%'
							},
							customTextStyle: {
								fontSize: '17pt'
							},
							onClicked: () => {
								props.parameters.onNextClicked();
							}
						}}/>
					</div>
				) : (
					<div style={{
						position: 'absolute',
						left: '20px',
						top: '200px',
						width: '751px',
						height: '420px'
					}}>
						<img className='spinner' style={{
							width: '310px',
							position: 'absolute',
							top: '0px',
							left: '230px'
						}} src="./assets/images/artifitial-progress/progress_arrows.png"/>
						<p style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							position: 'absolute',
							bottom: '13px',
							width: '100%'
						}} className="title-font">{spinnerText}</p>
					</div>
				)}
			</div>
		</div>
	);

};

export interface EttSpecialUIConfig extends BaseConfig{
	airwayImage: () => string;
	magillForceps: SpecialUIMagillForceps;
	suction: EttSpecialUIItemConfig;
	manipulateLarynx: EttSpecialUIItemConfig;
	onNextClicked?: () => void;
	onAbortClicked?: () => void
}

export interface SpecialUIMagillForceps extends EttSpecialUIItemConfig {
	isEnabled?: boolean;
	onAirwayImageClicked?: () => void;
}

export interface EttSpecialUIItemConfig {
	text: () => string;
	onClick?: () => void;
}

export default EttSpecialUI;